import { Geolocation } from "@ionic-native/geolocation";

export default {
  async getLocation() {
    return Geolocation.getCurrentPosition({ enableHighAccuracy: true });
  },
};
